var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex aligin-items-center justify-content-center my-4"},[_c('span',{staticClass:"d-flex align-items-center"},[_c('div',{staticClass:"lds-ellipsis"},[_c('div'),_c('div'),_c('div'),_c('div')]),_vm._v(" "),_c('span',{staticClass:"loader-text"},[_vm._v("Loading ...")])])])
}]

export { render, staticRenderFns }